import { financialConstants } from "./constants/financialConstants";

export type FinancialView = "payments" | "expenses" | "summary";

const getFinancialRequest = (eventId: string) => ({
  type: financialConstants.getFinancialRequest,
  payload: eventId,
});

const createPaymentRequest = (
  formData: FormData,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.createPaymentRequest,
  payload: { formData, eventId, onSuccess, onError },
});

const updatePaymentRequest = (
  paymentId: string,
  formData: FormData,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.updatePaymentRequest,
  payload: { paymentId, formData, eventId, onSuccess, onError },
});

const deletePaymentRequest = (paymentId: string, eventId: string) => ({
  type: financialConstants.deletePaymentRequest,
  payload: { paymentId, eventId },
});

const createFinancialAlertRequest = (
  data: any,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.createFinancialAlertRequest,
  payload: { data, eventId, onSuccess, onError },
});

const updateFinancialAlertRequest = (
  alertId: string,
  data: any,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.updateFinancialAlertRequest,
  payload: { alertId, data, eventId, onSuccess, onError },
});

const deleteFinancialAlertRequest = (alertId: string, eventId: string) => ({
  type: financialConstants.deleteFinancialAlertRequest,
  payload: { alertId, eventId },
});

const createExpenseRequest = (
  data: any,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.createExpenseRequest,
  payload: { data, eventId, onSuccess, onError },
});

const updateExpenseRequest = (
  expenseId: string,
  data: any,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.updateExpenseRequest,
  payload: { expenseId, data, eventId, onSuccess, onError },
});

const deleteExpenseRequest = (expenseId: string, eventId: string) => ({
  type: financialConstants.deleteExpenseRequest,
  payload: { expenseId, eventId },
});

const createPayoutRequest = (
  data: any,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.createPayoutRequest,
  payload: { data, eventId, onSuccess, onError },
});

const updatePayoutRequest = (
  payoutId: string,
  data: any,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.updatePayoutRequest,
  payload: { payoutId, data, eventId, onSuccess, onError },
});

const deletePayoutRequest = (payoutId: string, eventId: string) => ({
  type: financialConstants.deletePayoutRequest,
  payload: { payoutId, eventId },
});

const createExpenseContactRequest = (
  data: any,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.createExpenseContactRequest,
  payload: { data, eventId, onSuccess, onError },
});

const updateExpenseContactRequest = (
  contactId: string,
  data: any,
  eventId: string,
  onSuccess?: () => void,
  onError?: () => void
) => ({
  type: financialConstants.updateExpenseContactRequest,
  payload: { contactId, data, eventId, onSuccess, onError },
});

const deleteExpenseContactRequest = (contactId: string, eventId: string) => ({
  type: financialConstants.deleteExpenseContactRequest,
  payload: { contactId, eventId },
});

const setFinancialView = (eventId: string, view: FinancialView) => ({
  type: financialConstants.setFinancialView,
  payload: { eventId, view },
});

const clearFinancialState = () => ({
  type: financialConstants.clearFinancialState,
});

export const financialActions = {
  getFinancialRequest,
  createPaymentRequest,
  updatePaymentRequest,
  deletePaymentRequest,
  createFinancialAlertRequest,
  updateFinancialAlertRequest,
  deleteFinancialAlertRequest,
  createExpenseRequest,
  updateExpenseRequest,
  deleteExpenseRequest,
  createPayoutRequest,
  updatePayoutRequest,
  deletePayoutRequest,
  createExpenseContactRequest,
  updateExpenseContactRequest,
  deleteExpenseContactRequest,
  setFinancialView,
  clearFinancialState,
};

export default financialActions;
